// Layout.jsx
import React from 'react';
import { Container, Row, Col, Navbar, Nav } from 'react-bootstrap';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout = ({ children }) => {
  return (
    <div className="d-flex" id="wrapper">
      <Sidebar />
      <div id="page-content-wrapper" className="w-100">
        <Header />
        <Container fluid className="mt-3">
          {children}
        </Container>
      </div>
    </div>
  );
};

export default Layout;